function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import moment from "moment";
import { DatePicker, Space, Table, message, Button, Divider, Form, Tabs, Row as AdRow, Col as AdCol, Statistic, Modal } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import { Download, Cash, BuildingFill, ArrowRepeat, PeopleFill, ArrowLeftRight, CartCheckFill, ExclamationSquareFill, ListUl } from "react-bootstrap-icons";
import CompanyBills from "../components/CompanyBills";
import Moment from "react-moment";
import UserBills from "../components/UserBills";
import dayjs from 'dayjs';
import Autorisations from "../components/Autorisations";
import Expenses from "../components/Expenses";
import Ristourne from "../components/Ristourne";
import { useOutletContext } from "react-router-dom";
import AddSettlement from "../components/forms/AddSettlement";
import SettlementHistory from "../components/SettlementHistory";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var TabPane = Tabs.TabPane;

var Facturation = function Facturation() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listOfBills = _useState2[0],
      setListOfBills = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      billsArrayData = _useState4[0],
      setBillsArrayData = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataLoading = _useState6[0],
      setIsDataLoading = _useState6[1];

  var _useState7 = useState(moment().startOf('day').format()),
      _useState8 = _slicedToArray(_useState7, 2),
      from = _useState8[0],
      setFrom = _useState8[1];

  var _useState9 = useState(moment().endOf('day').format()),
      _useState10 = _slicedToArray(_useState9, 2),
      to = _useState10[0],
      setTo = _useState10[1];

  var _useOutletContext = useOutletContext(),
      _useOutletContext2 = _slicedToArray(_useOutletContext, 2),
      dataChanged = _useOutletContext2[0],
      setDataChanged = _useOutletContext2[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      totalIncomes = _useState12[0],
      setTotalIncomes = _useState12[1];

  var _useState13 = useState(0),
      _useState14 = _slicedToArray(_useState13, 2),
      totalCash = _useState14[0],
      setTotalCash = _useState14[1];

  var _useState15 = useState(0),
      _useState16 = _slicedToArray(_useState15, 2),
      totalEnt = _useState16[0],
      setTotalEnt = _useState16[1];

  var _useState17 = useState(0),
      _useState18 = _slicedToArray(_useState17, 2),
      totalExpenses = _useState18[0],
      setTotalExpenses = _useState18[1];

  var _useState19 = useState(0),
      _useState20 = _slicedToArray(_useState19, 2),
      totalValidated = _useState20[0],
      setTotalValidated = _useState20[1];

  var _useState21 = useState(0),
      _useState22 = _slicedToArray(_useState21, 2),
      totalPending = _useState22[0],
      setTotalPending = _useState22[1];

  var _useState23 = useState(0),
      _useState24 = _slicedToArray(_useState23, 2),
      balance = _useState24[0],
      setBalance = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      showSettle = _useState26[0],
      setShowSettle = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      showSettleHistory = _useState28[0],
      setShowSettleHistory = _useState28[1];

  var _useState29 = useState(null),
      _useState30 = _slicedToArray(_useState29, 2),
      selectedBill = _useState30[0],
      setSelectedBill = _useState30[1];

  var rangePresets = {
    "Aujourdh'ui": [moment().startOf('day'), moment().endOf('day')],
    'Cette semaine': [moment().startOf('week'), moment().endOf('week')],
    'Ce mois': [moment().startOf('month'), moment().endOf('month')]
  };
  var cols = [{
    title: "Date",
    dataIndex: "date",
    render: function render(date) {
      return /*#__PURE__*/_jsx(Moment, {
        format: "DD/MM/YYYY HH:mm",
        date: date
      });
    },
    key: "date"
  }, {
    title: "Patient",
    dataIndex: "patient",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "patient"
  }, {
    title: "Acte (s)",
    dataIndex: "acte",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "acte"
  }, {
    title: "Total (GNF)",
    dataIndex: "total",
    key: "total"
  }, {
    title: "Payé",
    dataIndex: "paid",
    key: "paid"
  }, {
    title: "Balance",
    dataIndex: "balance",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "balance"
  }, {
    title: "Paiement",
    dataIndex: "pay",
    render: function render(b) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "default",
          disabled: b.total_amount == b.paid_amount || b.company_id != null && b.company_id != 'null',
          onClick: function onClick() {
            setSelectedBill(b);
            setShowSettle(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(Cash, {
              size: 18
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          disabled: b.total_amount == b.paid_amount || b.company_id != null && b.company_id != 'null',
          onClick: function onClick() {
            setSelectedBill(b);
            setShowSettleHistory(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(ListUl, {
              size: 18
            })
          })
        })]
      });
    },
    key: "pay"
  }];

  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(billsArrayData, {
      str2Percent: true
    }).saveAs(from + "-" + to + ".xlsx");
  };

  var onSearchFinish = function onSearchFinish(values) {
    setListOfBills([]);
    setBillsArrayData([]);
    setFrom(moment(new Date(values.range[0].$d)).format());
    setTo(moment(new Date(values.range[1].$d)).format());
  };

  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getbills/" + moment(new Date(from)).format() + "/" + moment(new Date(to)).format() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setListOfBills([]);
        setListOfBills(response.data.bills);
        setBillsArrayData([]);
        response.data.bills.forEach(function (e) {
          var iar = [];
          e.bill_items.forEach(function (i) {
            if (i.business_account_medical_item != null) iar.push(i.business_account_medical_item.label);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: e.id,
              pay: e,
              date: e.created_at,
              patient: e.company_id == null ? e.customer.firstname + " " + e.customer.lastname : e.company.label,
              acte: iar.join(", "),
              total: e.total_amount.toLocaleString("Fr"),
              paid: e.paid_amount.toLocaleString("Fr"),
              balance: (e.total_amount - e.paid_amount).toLocaleString("Fr")
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [from, to, dataChanged]);
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getactivitysummary/" + moment(new Date(from)).format() + "/" + moment(new Date(to)).format() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setTotalIncomes(response.data.incomes);
        setTotalCash(response.data.cash);
        setTotalEnt(response.data.ent);
        setTotalExpenses(response.data.expenses);
        setTotalValidated(response.data.validated);
        setTotalPending(response.data.pending);
        setBalance(response.data.cash - response.data.expenses);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [from, to, dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 2,
            children: [/*#__PURE__*/_jsxs(TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Cash, {
                  size: 26
                }), " OPERATIONS"]
              }),
              children: [/*#__PURE__*/_jsx(Form, {
                onFinish: onSearchFinish,
                layout: "horizontal",
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "range",
                    rules: [{
                      required: true,
                      message: "Champs obligatoire"
                    }],
                    children: /*#__PURE__*/_jsx(RangePicker, {
                      needConfirm: false,
                      format: "DD-MM-YYYY"
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "RECHERCHE"
                      })
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      onClick: handleExport,
                      style: {
                        background: "#34C482"
                      },
                      icon: /*#__PURE__*/_jsx(Download, {
                        size: 16
                      }),
                      children: /*#__PURE__*/_jsx("b", {
                        children: "EXPORTER"
                      })
                    })
                  })]
                })
              }), /*#__PURE__*/_jsxs("div", {
                style: {
                  fontWeight: "bold",
                  fontStyle: 'italic'
                },
                children: ["Rapport d'activit\xE9s du ", new Date(from).toLocaleDateString("Fr"), " Au ", new Date(to).toLocaleDateString("Fr")]
              }), /*#__PURE__*/_jsxs(AdRow, {
                gutter: 16,
                children: [/*#__PURE__*/_jsx(AdCol, {
                  lg: 8,
                  children: /*#__PURE__*/_jsx("div", {
                    className: "stat_box",
                    style: {
                      background: "#D4DDD0"
                    },
                    children: /*#__PURE__*/_jsx(Statistic, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Montant Recette"
                      }),
                      value: totalIncomes
                    })
                  })
                }), /*#__PURE__*/_jsx(AdCol, {
                  lg: 8,
                  children: /*#__PURE__*/_jsx("div", {
                    className: "stat_box",
                    style: {
                      background: "#DDDCCB"
                    },
                    children: /*#__PURE__*/_jsx(Statistic, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Montant Cash"
                      }),
                      value: totalCash
                    })
                  })
                }), /*#__PURE__*/_jsx(AdCol, {
                  lg: 8,
                  children: /*#__PURE__*/_jsx("div", {
                    className: "stat_box",
                    style: {
                      background: "#DADBDD"
                    },
                    children: /*#__PURE__*/_jsx(Statistic, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Montant Entreprises"
                      }),
                      value: totalEnt
                    })
                  })
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(AdRow, {
                gutter: 16,
                children: [/*#__PURE__*/_jsx(AdCol, {
                  lg: 7,
                  children: /*#__PURE__*/_jsx("div", {
                    className: "stat_box",
                    style: {
                      background: "#DDDCCB"
                    },
                    children: /*#__PURE__*/_jsx(Statistic, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Total D\xE9penses"
                      }),
                      value: totalExpenses
                    })
                  })
                }), /*#__PURE__*/_jsx(AdCol, {
                  lg: 7,
                  children: /*#__PURE__*/_jsx("div", {
                    className: "stat_box",
                    style: {
                      background: "#DDD6D6"
                    },
                    children: /*#__PURE__*/_jsx(Statistic, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: "D\xE9penses valid\xE9s"
                      }),
                      value: totalValidated
                    })
                  })
                }), /*#__PURE__*/_jsx(AdCol, {
                  lg: 7,
                  children: /*#__PURE__*/_jsx("div", {
                    className: "stat_box",
                    style: {
                      background: "#DDD6D6"
                    },
                    children: /*#__PURE__*/_jsx(Statistic, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: "D\xE9penses en attente"
                      }),
                      value: totalPending
                    })
                  })
                }), /*#__PURE__*/_jsx(AdCol, {
                  lg: 3,
                  children: /*#__PURE__*/_jsx("div", {
                    className: "stat_box",
                    style: {
                      background: "#DDDCCB"
                    },
                    children: /*#__PURE__*/_jsx(Statistic, {
                      title: /*#__PURE__*/_jsx("b", {
                        children: "Solde"
                      }),
                      value: balance
                    })
                  })
                })]
              }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("div", {
                style: {
                  fontWeight: "bold",
                  fontStyle: 'italic'
                },
                children: ["Recettes du ", new Date(from).toLocaleDateString("Fr"), " Au ", new Date(to).toLocaleDateString("Fr")]
              }), /*#__PURE__*/_jsx(Table, {
                size: "small",
                columns: cols,
                bordered: true,
                loading: isDataLoading,
                dataSource: billsArrayData,
                pagination: true
              })]
            }, 1), /*#__PURE__*/_jsx(TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BuildingFill, {
                  size: 26
                }), " SOCIETES"]
              }),
              children: /*#__PURE__*/_jsx(CompanyBills, {})
            }, 3), /*#__PURE__*/_jsx(TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PeopleFill, {
                  size: 26
                }), " AGENTS"]
              }),
              children: /*#__PURE__*/_jsx(UserBills, {})
            }, 5), /*#__PURE__*/_jsx(TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(CartCheckFill, {
                  size: 26
                }), " DEPENSES"]
              }),
              children: /*#__PURE__*/_jsx(Expenses, {})
            }, 6), /*#__PURE__*/_jsx(TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(ArrowRepeat, {
                  size: 26
                }), " RISTOURNES"]
              }),
              children: /*#__PURE__*/_jsx(Ristourne, {})
            })]
          })
        })
      })
    }), selectedBill && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "R\xE9gler la facture"
        }),
        open: showSettle,
        onCancel: function onCancel() {
          setShowSettle(false);
        },
        destroyOnClose: true,
        footer: null,
        width: {
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(AddSettlement, {
          bill: selectedBill,
          handler: function handler() {
            setDataChanged(true);
            setShowSettle(false);
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Historique des paiements"
        }),
        open: showSettleHistory,
        onCancel: function onCancel() {
          setShowSettleHistory(false);
        },
        destroyOnClose: true,
        footer: null,
        width: {
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(SettlementHistory, {
          bill: selectedBill,
          handler: function handler() {
            setDataChanged(true);
            setShowSettleHistory(false);
          }
        })
      })]
    })]
  });
};

export default Facturation;